import {
    ref
} from 'vue';
let obj={}
export const sysDataDictionaryWbObj = ref(obj);